function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import firebase from 'firebase';
import 'firebase/firebase-messaging';
import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import config from '../../../../configs';
import { ROLES_LIST } from '@/js/constants';
import IncaMetrics from '@/apps/data-platform/modules/home_page/IncaMetrics.vue';
import MyIncaMetrics from '@/apps/data-platform/modules/home_page/MyIncaMetrics.vue';
import HubIaMigrationDialog, { HUB_IA_MENU_KEY } from '@/apps/chatbots/components/HubIaMigrationDialog';
export default {
  components: {
    MyIncaMetrics: MyIncaMetrics,
    IncaMetrics: IncaMetrics,
    HubIaMigrationDialog: HubIaMigrationDialog
  },
  data: function data() {
    return {
      navigation: config.navigation,
      items: [],
      isLoading: false,
      selected: [0],
      keyNotifications: 1,
      color: '#DEEBFF'
    };
  },
  created: function created() {
    this.onFilterMenu(),
    // console.log("asd", this.navigation)
    this.startListeners();
    // console.log(this.userInfo.userRoles)
  },
  methods: _objectSpread(_objectSpread({}, mapActions('data-platform', ['getUserNotifications'])), {}, {
    startListeners: function () {
      var _startListeners = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.startOnMessageListener();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function startListeners() {
        return _startListeners.apply(this, arguments);
      }
      return startListeners;
    }(),
    startOnMessageListener: function () {
      var _startOnMessageListener = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                if (firebase.messaging.isSupported()) {
                  firebase.messaging().onMessage(function (payload) {
                    console.info('Message received : ', payload);
                    // console.log("asd", payload.notification.body)
                    _this.getNotifications();
                  });
                }
              } catch (e) {
                console.error('Error : ', e);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function startOnMessageListener() {
        return _startOnMessageListener.apply(this, arguments);
      }
      return startOnMessageListener;
    }(),
    getNotifications: function getNotifications() {
      var _this2 = this;
      this.isLoading = true;
      this.getUserNotifications(this.userEmail).then(function () {
        _this2.isLoading = false;
        _this2.keyNotifications = _this2.keyNotifications + 1;
      });
    },
    onClickNotification: function onClickNotification(notification) {
      var _this3 = this;
      var notificationId = notification.document_id;
      if (notification.link) {
        window.open(notification.link, '_blank');
      } else if (notification.path) {
        this.$router.push({
          path: notification.path
        });
      }
      if (!notification.read) {
        var data = {
          dataUpdate: {
            read: true
          }
        };
        userSettingsService.updateNotification(this.userEmail, notificationId, data).then(function (response) {
          _this3.getUserNotifications();
        });
      }
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    go_to: function go_to(route) {
      // Hub IA convive en dos versiones: se elige en el modal antes de entrar.
      if (route.key === HUB_IA_MENU_KEY) {
        this.$refs.hub_ia_dialog.onOpen();
        return;
      }
      this.$store.commit('app/setMenuSelected', route.key);
      this.$router.push({
        name: route.principal
      });
    },
    onFilterMenu: function onFilterMenu() {
      var _this4 = this;
      var _menu = Object.assign([], this.navigation.menu).filter(function (x) {
        return x.pantallaInicial;
      });
      //_menu.shift()
      var arrayStrings = ['data_platform', 'audience', 'attribute', 'insights', 'ml', 'dataops'];
      _menu.forEach(function (x) {
        x.name_i18n = _this4.traductor(x.key);
      });
      _menu.forEach(function (x, index) {
        x.id = arrayStrings[index];
      });
      var array = this.userInfo.userRoles;
      var dictionary = ROLES_LIST;
      var rolesUserLogged = Object.keys(dictionary).filter(function (key) {
        return array.includes(dictionary[key]);
      });
      var separatedRoles = {
        data_platform: [],
        audience: [],
        attribute: [],
        insights: [],
        dataops: [],
        ml: []
      };
      var prefixes = ['AUDIENCE_', 'ATTRIBUTE_', 'INSIGHTS_', 'ML_', 'DATAOPS_'];
      var _iterator = _createForOfIteratorHelper(rolesUserLogged),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var role = _step.value;
          var found = false;
          var _iterator2 = _createForOfIteratorHelper(prefixes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var prefix = _step2.value;
              if (role.startsWith(prefix)) {
                separatedRoles[prefix.toLowerCase().slice(0, -1)].push(ROLES_LIST[role]);
                found = true;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (!found) {
            separatedRoles.data_platform.push(ROLES_LIST[role]);
          }
        }
        // verificar si tiene el role admin
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (array.includes(ROLES_LIST.ORG_DATA_STEWARD)) {
        Object.keys(separatedRoles).forEach(function (x) {
          if (separatedRoles[x].length == 0) {
            separatedRoles[x].push(ROLES_LIST.ORG_DATA_STEWARD);
          }
        });
      }
      // console.log("lengt", _menu.length)
      for (var i = 0; i < _menu.length; i++) {
        var id = _menu[i].id;
        if (separatedRoles[id]) {
          _menu[i].roles_user = separatedRoles[id];
        }
      }
      console.log("final: ", _menu);
      return _menu;
    },
    getString: function getString(roles) {
      var string = '';
      if (roles.length === 1) {
        string = roles[0];
      } else if (roles.length === 2) {
        string = roles[0] + ', ' + roles[1];
      } else if (roles.length > 2) {
        string = roles[0] + ', ' + roles[1] + ' + ' + (roles.length - 2) + ' más';
      }
      return string;
    },
    checkRoles: function checkRoles(roles) {
      if (roles && roles.length == 0) {
        return false;
      }
      return true;
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['userNotifications'])), {}, {
    newNotifications: function newNotifications() {
      var notificationsNew = this.userNotifications.filter(function (item) {
        return item.read === false;
      });
      return notificationsNew.length;
    },
    notificationsUnread: {
      get: function get() {
        var unread = [];
        this.userNotifications.forEach(function (item, index) {
          if (item.read === false) {
            unread.push(index);
          }
        });
        return unread;
      },
      set: function set(newValue) {}
    },
    getFromNowLocale: function getFromNowLocale() {
      var _this5 = this;
      return function (created) {
        _this5.$moment.locale(_this5.$i18n.locale);
        return _this5.$moment(created).fromNow();
      };
    },
    notificationRead: function notificationRead() {
      return function (item) {
        return item.read === true;
      };
    }
  })
};